<template>
<!--  <DeveloperTool>-->
<!--    <template v-slot:app>-->
      <div id="app" :class="vueAppClasses">
        <transition name="pages">
          <router-view @setAppClasses="setAppClasses" />
        </transition>
      </div>
<!--    </template>-->
<!--  </DeveloperTool>-->
</template>

<script>
import store from "@/store";
// import themeConfig from '@/../themeConfig.js'
import {themeConfig} from '@/constants/config';
import theme from '@/store/modules/theme';
// import {createNamespacedHelpers} from 'vuex';

import datastore from "@/developing/datastore";

if (!store.state.theme) store.registerModule(`theme`, theme);


// import Communication from '@/developing/store/modules/communication';
// console.log("Communication", Communication);

// if (!store.state.Communication) { store.registerModule(`Communication`, Communication); }
// console.log(store.state);

  // const {
  //   mapState: mapThemeState,
  //   mapMutations: mapThemeMutation
  // } = createNamespacedHelpers(`theme`);

export default {
  // components: {
  //   DeveloperTool: () => import("@/developing/dev-components/DeveloperTool")
  // },
  data() {
    return {
      vueAppClasses: []
    }
  },
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl'(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
    }
  },
  methods: {
    toggleClassInBody(className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    },
    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },
    async initUser() {
      if (!this.$store.state.User.currentUser || !this.$store.state.User.profile) {
        await this.$store.dispatch("User/initUser", null, { root: true });
      }
    },
  },
  async mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth);

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // this.$store.dispatch('MasterData/getAllMasterData');
    await this.initUser();
  },
  async beforeCreate() {
    // Load and rebuild list of contents in background (Notifications, Messages) from disk cache (IndexedDB);
    await datastore.restore();
  },
  async created() {

    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener('scroll', this.handleScroll);

  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('scroll', this.handleScroll)
  },
}

</script>

<style lang="scss">
.pages-enter-active, .pages-leave-active {
  transition: opacity .5s;
}
.pages-enter, .pages-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
